import React from "react"
import { Box, Typography, Button } from "@mui/material"

export const NotFoundRestaurant = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          fontSize: "120px",
          fontWeight: "700",
          color: "#e0e0e0",
          lineHeight: "1",
          marginBottom: "20px",
        }}
      >
        404
      </Box>
      <Typography
        variant="h4"
        sx={{
          marginBottom: "12px",
          fontWeight: "600",
          color: "#333",
        }}
      >
        Restaurant Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "8px",
          color: "#666",
          maxWidth: "400px",
        }}
      >
        The restaurant you are looking for does not exist or is no longer available.
      </Typography>
      <Typography
        variant="body2"
        sx={{
          marginBottom: "32px",
          color: "#999",
          maxWidth: "400px",
        }}
      >
        Please check the QR code or link and try again.
      </Typography>
      <Button
        variant="contained"
        onClick={() => {
          window.location.href = "/?restaurant_id=2&qr_name=Table%201"
        }}
        sx={{
          marginBottom: "32px",
          textTransform: "none",
        }}
      >
        Example
      </Button>
      <Box
        sx={{
          width: "200px",
          height: "200px",
          marginBottom: "24px",
          opacity: 0.3,
        }}
      >
        <svg
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="100" cy="100" r="80" stroke="#999" strokeWidth="4" />
          <path
            d="M70 70L130 130M130 70L70 130"
            stroke="#999"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </Box>
    </Box>
  )
}
